import { DataManager, ODataV4Adaptor, Query } from '@syncfusion/ej2-data';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import { MultiSelectComponent } from '@syncfusion/ej2-react-dropdowns';
import React, { useEffect, useState } from 'react';
import { loadingShow } from '../../App';
import GlobalGrid from '../../components/GlobalGrid';
import {
  assetCostModelCrud,
  assetCostModelHeaderCrud,
  assetCostModelStatistic,
} from '../../services/AssetCostModelServices/AssetCostModelServices';
import Message from '../../utils/Message/Message';
import {
  CheckBoxSelection,
  Inject as DDInject,
} from '@syncfusion/ej2-react-dropdowns';
import GlobalSearch from '../../components/GlobalSearch';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { GetBackendUrlForGlobalFunctions } from '../../App';
import {
  columns,
  columnsOfForecast,
  columnsOfForecastAggregate,
} from './Columns';
import { FiChevronDown } from 'react-icons/fi';
import './AssetCostModel.css';
import ACMHeader from './ACMHeader';
import { useQuery } from 'react-query';
import { useCustomQuery } from '../../utils/Hooks';
import Cookies from "js-cookie";
let the_current_query = '';
let resultLikeQuery = '';
let theQuerySearch = '';
let theQueryHeaderID = '';
let theQueryType = '';
let theQueryAsset = '';
const queryOfAsset = new Query().take(20);
const groupOptions: Object = {
  showGroupedColumn: true,
  columns: ['pid', 'plant_no'],
};
var assetFilterMultiSelectCom: MultiSelectComponent = new MultiSelectComponent(
  {}
);
var typeFilterMultiSelectCom: MultiSelectComponent = new MultiSelectComponent(
  {}
);
var assetFilterMultiSelectComValue: any = undefined;
var typeFilterMultiSelectComValue: string = '';
let current_header_data: any = [];
function AssetCostModel() {
  const [current_query_forecast, setCurrent_query_forecast] = useState('');
  const [loadSignalUnderHeader, setLoadSignalUnderHeader] = useState(false);
  // const theURL = useCustomQuery(
  //   true,
  //   "1$150",
  //   current_query_forecast,
  //   true,
  //   "asset-cost-model/forecast/get"
  // );
  // const { isLoading, error, data } = useQuery('repoData', () =>
  //   fetch(theURL).then((res) => res.json())
  // );
  const token = Cookies.get('token');

  var assetDatasource: DataManager = new DataManager({
    adaptor: new ODataV4Adaptor(),
    crossDomain: true,
    url: GetBackendUrlForGlobalFunctions() + `assets/search`,
    headers: [{
      Authorization: `Bearer ${token}`,
      contentType: 'application/json',
    }],
  });

  const buildQuery = (loadSignal: boolean) => {
    the_current_query = current_query_forecast.trim();
    the_current_query = the_current_query.replace(theQuerySearch, '');
    the_current_query = the_current_query.replace(theQueryHeaderID, '');

    the_current_query = the_current_query.replace(theQueryAsset, '');
    the_current_query = the_current_query.replace(theQueryType, '');

    var taskNo = typeFilterMultiSelectComValue?.toString();
    let theAssetsTemp: Array<any> = [];
    assetFilterMultiSelectComValue?.map((el: any) => {
      theAssetsTemp.push(`'${el.trim().trimEnd().trimStart()}'`);
    });
    var theAssets = theAssetsTemp?.toString();

    if (theAssets !== '' && theAssets !== undefined) {
      if (the_current_query !== '') {
        theQueryAsset = addToQuery(
          'asset_code',
          'in',
          'andWhere',
          theAssets?.toString(),
          theQueryAsset
        );
      } else {
        theQueryAsset = addToQuery(
          'asset_code',
          'in',
          'where',
          theAssets?.toString(),
          theQueryAsset
        );
      }
    }
    if (taskNo !== '' && taskNo !== undefined) {
      if (the_current_query !== '') {
        theQueryType = addToQuery(
          'plt_pm_task_no',
          'in',
          'andWhere',
          taskNo,
          theQueryType
        );
      } else {
        theQueryType = addToQuery(
          'plt_pm_task_no',
          'in',
          'where',
          taskNo,
          theQueryType
        );
      }
    }
    if (resultLikeQuery !== '') {
      if (the_current_query !== '') {
        theQuerySearch = ' and (' + resultLikeQuery + ')';
        the_current_query = the_current_query + theQuerySearch;
      } else {
        theQuerySearch = ' (' + resultLikeQuery + ')';
        the_current_query = the_current_query + theQuerySearch;
      }
    }
    if (current_header_data?.id != undefined) {
      if (the_current_query !== '') {
        theQueryHeaderID = addToQuery(
          'p_id',
          '=',
          'andWhere',
          current_header_data?.id,
          theQueryHeaderID
        );
      } else {
        theQueryHeaderID = addToQuery(
          'p_id',
          '=',
          'where',
          current_header_data?.id,
          theQueryHeaderID
        );
      }
    }
    setLoadSignalUnderHeader(loadSignal);
    setCurrent_query_forecast(the_current_query);
  };
  const addToQuery = (
    field: string,
    c: string,
    type: string,
    v: string,
    the_inner_current_query: string
  ) => {
    the_inner_current_query = JSON.stringify({
      f: field,
      c: c,
      t: type,
      v: v,
    });
    the_inner_current_query += '?';
    the_current_query += the_inner_current_query;
    return the_inner_current_query;
  };
  const ApplyFilter = () => {
    buildQuery(true);
  };
  const clearFilter = () => {
    assetFilterMultiSelectComValue = [];
    typeFilterMultiSelectComValue = '';
    if (current_query_forecast !== '') {
      buildQuery(true);
    }
  };
  const onFiltering = (e: any) => {
    let query = new Query().take(20);
    query = e.text !== '' ? query.where('assetCode', 'equal', e.text) : query;
    e.updateData(assetDatasource, query);
  };
  const AssetInput = () => {
    return (
      <div>
        <MultiSelectComponent
          ref={(scope: MultiSelectComponent) => {
            assetFilterMultiSelectCom = scope;
          }}
          dataSource={assetDatasource}
          fields={{ text: 'assetCode', value: 'assetCode' }}
          placeholder='Select a Asset'
          mode='CheckBox'
          query={queryOfAsset}
          filtering={onFiltering}
          showClearButton={true}
          showDropDownIcon={true}
          allowFiltering={true}
          filterBarPlaceholder='Search a Asset'
          onChange={(e: any) => {
            assetFilterMultiSelectComValue = e.value;
          }}
        >
          <DDInject services={[CheckBoxSelection]} />
        </MultiSelectComponent>
      </div>
    );
  };
  const TaskNoInput = () => {
    return (
      <div>
        <TextBoxComponent
          placeholder='Task No'
          delayUpdate={true}
          value={typeFilterMultiSelectComValue}
          onChange={(e: any) => {
            typeFilterMultiSelectComValue = e.value;
          }}
        ></TextBoxComponent>
      </div>
    );
  };
  const expandHeaderClick = () => {
    $('.asset-cost-collapse-zone').toggleClass('show-content-for-collapse');
    $('#rotate-icon-asset-cost-model').toggleClass('rotateIcon-for-collapse');
  };
  const handleHeaderGridRowSelected = (args: any) => {
    current_header_data = args.data;
    buildQuery(true);
  };
  const handleHeaderGridRowDeselected = (args: any) => {
    current_header_data = [];
    buildQuery(false);
  };
  return (
    <div>
      <div className='asset-cost-model-content'>
        <div className='collapse-parent-div'>
          <div
            onClick={expandHeaderClick}
            className='collapse-sub-flex collapse-first'
          >
            <div className='collapse-icon-div collapse-flex'>
              <FiChevronDown
                id='rotate-icon-asset-cost-model'
                className='rotateIcon-for-collapse'
                size={17}
              />
            </div>
          </div>
          <div className='asset-cost-collapse-zone'>
            <ACMHeader
              theHeaderGridRowDeselected={handleHeaderGridRowDeselected}
              theHeaderGridRowSelected={handleHeaderGridRowSelected}
              refreshForecast={() => buildQuery(true)}
            />
          </div>
        </div>
        <div className='container-tasktracker'>
          <GlobalGrid
            id='acmforecast'
            columns={columnsOfForecast}
            height={'50vh'}
            query={current_query_forecast}
            get_query={'asset-cost-model/forecast/get'}
            enableAggregate={true}
            aggregateColumns={columnsOfForecastAggregate}
            groupSettings={groupOptions}
            enablePagination={false}
            signalOfLoad={loadSignalUnderHeader}
          />
        </div>
        <GlobalSearch
          id='asset-cost-modeling-filter'
          height={'286px'}
          applyFilter={ApplyFilter}
          clearFilter={clearFilter}
          Component3={AssetInput}
          Component1={TaskNoInput}
        />
      </div>
    </div>
  );
}

export default AssetCostModel;
